import React from "react";
import { Item } from "semantic-ui-react";

import PostCard from "./PostCard";

interface PostCardListProps {
  data: any;
  useImage?: boolean;
}

export const PostCardList: React.FC<PostCardListProps> = ({
  data,
  useImage = false,
}) => {
  const postCards = data.map(post => {
    return (
      <PostCard
        key={post.id}
        id={post.id}
        excerpt={post.excerpt}
        slug={post.fields.slug}
        useImage={useImage}
        timeToRead={post.timeToRead}
        {...post.frontmatter}
      />
    );
  });

  return <Item.Group divided>{postCards}</Item.Group>;
};

export default PostCardList;
